import { Injectable } from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class IntegrationServices {
    public apiUrl = `${environment.apiUrl}/api/v1`;
    public companyId = global['loginUser'].curCmpnId;

    constructor(private http: Http) {

    };

    /**
     * integration
     * service List 조회
     * Mothod : Get
     * API No : 6.01
     * /api/v1/{cmpnNo}/integration/servicelist
     * /api/v1/{cmpnNo}/integration/query/{queryType}     singlesvc, multisvc
     **/
    getServiceList(queryType) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/query/${queryType}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getIntegrationList(queryString) {
        //const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/query/${queryType}`;
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration?${queryString}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * service Integration 조회
     * Mothod : Get
     * API No : 6.02
     * /api/v1/{cmpnNo}/integration/service/{svcNo}
     * /api/v1/{cmpnNo}/integration/service?itgrnos={itgrApplInstlNo}
     **/
    getServiceIntegration(queryString) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/service?${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * service escalation rule 조회
     * Mothod : Get
     * API No : 6.04
     * /api/v1/{cmpnNo}/integration/service/{svcNo}/escalrule
     **/
    getServiceEscalationRule(svcNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/service/${svcNo}/escalrule`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Service escalation rule 수정
     * Mothod : Put
     * API No : 6.06
     * /api/v1/{cmpnNo}/integration/service/{svcNo}/escalrule
     **/
    updateServiceEscalationRule(svcNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/service/${svcNo}/escalrule`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * service alert rule 조회
     * Mothod : Get
     * API No : 6.07
     * /api/v1/{cmpnNo}/integration/service/{svcNo}/alertrule
     **/
    getServiceAlertRule(svcNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/service/${svcNo}/alertrule`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Service alert rule 수정
     * Mothod : Put
     * API No : 6.09
     * /api/v1/{cmpnNo}/integration/service/{svcNo}/alertrule
     **/
    updateServiceAlertRule(svcNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/service/${svcNo}/alertrule`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Integration group Name 수정
     * Mothod : Put
     * API No : 6.10
     * /api/v1/{cmpnNo}/integration/group/{itgrCnfgGrpNo}/name
     **/
    updateIntegrationGroupName(itgrCnfgGrpNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/group/${itgrCnfgGrpNo}/name`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);

    }

    /**
     * integration
     * Integration Group escalation rule 조회
     * Mothod : Get
     * API No : 6.11
     * /api/v1/{cmpnNo}/integration/group/{itgrCnfgGrpNo}/escalrule
     **/
    getIntegrationGroupEscalationRule(itgrCnfgGrpNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/group/${itgrCnfgGrpNo}/escalrule`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Integration Group alert rule 조회
     * Mothod : Get
     * API No : 6.14
     * /api/v1/{cmpnNo}/integration/group/{itgrCnfgGrpNo}/alertrule
     **/
    getIntegrationGroupAlertRule(itgrCnfgGrpNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/group/${itgrCnfgGrpNo}/alertrule`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Integration group 생성
     * Mothod : Post
     * API No : 6.17
     * /api/v1/{cmpnNo}/integration/group
     **/

    createIntegrationGroup(postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/group`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Integration 상세 조회
     * Mothod : Get
     * API No : 6.19
     * /api/v1/{cmpnNo}/integration/{itgrApplInstlNo}
     **/
    getIntegration(itgrApplInstlNo, itgrType?) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrType !== undefined ? itgrType + '/' : ''}${itgrApplInstlNo}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Integration escalation rule 조회
     * Mothod : Get
     * API No : 6.20
     * /api/v1/{cmpnNo}/integration/{itgrApplInstlNo}/escalrule
     **/
    getIntegrationEscalationRule(itgrApplInstlNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrApplInstlNo}/escalrule`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * integration escalation rule 수정
     * Mothod : Put
     * API No : 6.22
     * /api/v1/{cmpnNo}/integration/{itgrApplInstlNo}/escalrule
     **/
    updateIntegrationEscalationRule(itgrApplInstlNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrApplInstlNo}/escalrule`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Integration alert rule 조회
     * Mothod : Get
     * API No : 6.23
     * /api/v1/{cmpnNo}/integration/{itgrApplInstlNo}/alertrule
     **/
    getIntegrationAlertRule(itgrApplInstlNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrApplInstlNo}/alertrule`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * integration alert rule 수정
     * Mothod : Put
     * API No : 6.25
     * /api/v1/{cmpnNo}/integration/{itgrApplInstlNo}/alertrule
     **/
    updateIntegrationAlertRule(itgrApplInstlNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrApplInstlNo}/alertrule`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * integration 등록
     * Mothod : Post
     * API No : 6.26
     * /api/v1/{cmpnNo}/integration
     **/
    postIntegration(postData: any, itgrType?) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration${itgrType !== undefined ? '/' + itgrType : ''}`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * integration type 조회
     * Mothod : Get
     * API No : 6.27
     * /api/v1/{cmpnNo}/integration/type
     **/
    getIntegrationType(queryString?) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/type${queryString ? queryString : ''}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * integration 기본정보 수정
     * Mothod : Put
     * API No : 6.28
     * /api/v1/{cmpnNo}/integration/{itgrApplInstlNo}
     **/
    updateIntegrationBasicInfo(itgrApplInstlNo, putData: any, itgrType?) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrType !== undefined ? itgrType + '/' : ''}${itgrApplInstlNo}`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * integration name 수정
     * Mothod : Put
     * API No : 6.29
     * /api/v1/{cmpnNo}/integration/{itgrApplInstlNo}/name
     **/
    updateIntegrationName(itgrApplInstlNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrApplInstlNo}/name`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);

    }

    /**
     * integration
     * Integration API Key 발급
     * Method : Get
     * API No : 6.30
     * /api/v1/{cmpnNo}/integration/{itgrApplNo}/apikey
     */
    getApiKey(itgrApplNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrApplNo}/apikey`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Integration Group 조회
     * Mothod : Get
     * API No : 6.32
     * /api/v1/{cmpnNo}/integration/group/{integrationCnfgGrpNo}
     **/
    getIntegrationGroup(integrationCnfgGrpNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/group/${integrationCnfgGrpNo}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Message Spec Fild조회 => 서비스 라우팅룰에 사용
     * Method : Get
     * API No : 6.33
     * /api/v1/{cmpnNo}/integration/msgspec
     */
    getMsgSpec() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/msgspec`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }


    getRunBookList() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/runbook`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Rule Action 조회 => 에스컬레이션룰에 사용
     * Method: Get
     * API No: 3.34
     * /api/v1/{cmpnNo}/integration/ruleactn/{exeCmdCd}
     */

    getRuleAction(exeCmdCd: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/ruleactn/${exeCmdCd}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * integration 삭제
     * Mothod : Put
     * API No : 6.35
     * /api/v1/{cmpnNo}/integration/{integrationApplInstlNo}/status
     **/
    deleteIntegration(itgrApplInstlNo, itgrType?) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrType !== undefined ? itgrType + '/' : ''}${itgrApplInstlNo}/status`;

        return this.http
            .put(url, JSON.stringify(''))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);

    }

    /**
     * integration
     * CA-UIM 회사별 모니터링 그룹 조회
     * Mothod : Get
     * API No :
     * /api/v1/{cmpnNo}/integration/cauim/{itgrApplNo}/cmpn/origins
     **/
    getCompanyOrigins(itgrApplNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/cauim/${itgrApplNo}/cmpn/origins`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Integration Message Spec Field 조회 => Integration custom summary 규칙 등록에 사용
     * Method: Get
     * API No: 3.35
     * /api/v1/{cmpnNo}/integration/{integrationApplNo}/msgspec
     */

    getMsgSpecField(itgrApplNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrApplNo}/msgspec`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * integration
     * Sams Full Path Text 조회
     * Mothod : Get
     * API No :
     * /api/v1/{cmpnNo}/integration/sams/samscls/{itgrApplInstlNo}
     **/
    getSamsFullPathText(itgrApplInstlNo?) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/sams/samscls${itgrApplInstlNo !== undefined ? '/' + itgrApplInstlNo : ''}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getCategory() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/category`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getItgrEvtListByItgrNo(itgrApplNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/${itgrApplNo}/itgrevt`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }


    checkJiraProjectKeyExists(projectKey: string, jiraUrl: string, excludeIntegrationNo?: number) {
        let url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/integration/jira-projects/exists?projectKey=${projectKey}&jiraUrl=${encodeURIComponent(jiraUrl)}`;

        if (excludeIntegrationNo) {
            url += `&excludeIntegrationNo=${excludeIntegrationNo}`;
        }

        return this.http.get(url).toPromise().then(res => {
            return res.json();
        }).catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/integration.services.ts